import { gql } from '@apollo/client/core';

const ApproveTestimonialForPublicPortfolioCurrentUser = gql`
  mutation ApproveTestimonialForPublicPortfolioCurrentUser(
    $input: ApproveTestimonialForPublicPortfolioCurrentUserInput!
  ) {
    approveTestimonialForPublicPortfolioCurrentUser(input: $input) {
      state
    }
  }
`;

export default ApproveTestimonialForPublicPortfolioCurrentUser;
